import type { MaybeRefOrGetter } from 'vue'
import { computed, ref, toValue } from 'vue'

export function useComboboxFilter<T>(
  items: MaybeRefOrGetter<T[] | undefined | null>,
  getSearchText: (item: T) => string | null | undefined,
) {
  const open = ref(false)
  const query = ref('')
  const filtered = computed(() => {
    const list = toValue(items) ?? []
    const q = query.value.trim().toLowerCase()
    if (!q) {
      return list
    }
    return list.filter(item => getSearchText(item)?.toLowerCase().includes(q))
  })
  function reset() {
    open.value = false
    query.value = ''
  }
  return { open, query, filtered, reset }
}
